module.exports = __webpack_public_path__ + "static/media/time.9007a87b.svg";